import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <main className="min-h-screen relative pt-24 pb-24">
      {/* Ambient background glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -z-10 pointer-events-none"></div>
      
      <section className="max-w-4xl mx-auto px-margin-mobile md:px-margin-desktop">
        
        {/* Breadcrumbs */}
        <div className="flex items-center space-x-2 text-[12px] text-on-surface-variant mb-12">
          <Link to="/" className="hover:text-primary transition-colors">Home</Link>
          <span>/</span>
          <span className="text-silver-text">Privacy Policy</span>
        </div>

        {/* Header */}
        <div className="mb-16">
          <div className="bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded inline-block mb-6 border border-primary/20">
            Legal Agreements
          </div>
          <h1 className="font-display-lg text-[48px] md:text-[64px] font-bold text-silver-text mb-4 leading-tight">
            Privacy <span className="text-primary">Policy</span>
          </h1>
          <p className="text-[14px] text-on-surface-variant">
            Last Updated: June 4, 2026
          </p>
        </div>

        {/* Content */}
        <div className="space-y-12 text-[15px] text-on-surface-variant leading-relaxed">
          
          {/* Section 1 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">1. Information We Collect</h2>
            <p className="mb-4">
              We collect information necessary to process transactions, manage accounts, provide customer support, and improve our services:
            </p>
            <ul className="list-disc pl-5 space-y-3">
              <li><strong className="text-silver-text">Personal Identifiable Information:</strong> Name, email address, WhatsApp contact number (when provided in custom request forms), and order details.</li>
              <li><strong className="text-silver-text">Payment Information:</strong> All payment processing is done securely through certified third-party payment gateways. We do not store or process card numbers, bank credentials, or full transaction details on our servers.</li>
              <li><strong className="text-silver-text">System and Device Data:</strong> IP addresses, browser types, operating systems, and page navigation sequences.</li>
            </ul>
          </div>

          {/* Section 2 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">2. Analytics and Tracking</h2>
            <p>
              We implement lightweight server logging and third-party web analytics (such as Google Analytics or custom trackers) to monitor traffic patterns, identify performance bottlenecks, and prevent security vulnerabilities. These logs collect non-identifiable usage statistics to optimize page transitions and loading speeds.
            </p>
          </div>

          {/* Section 3 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">3. Cookies and Session Tracking</h2>
            <p className="mb-4">
              Cookies are small files stored on your computer to assist website function:
            </p>
            <ul className="list-disc pl-5 space-y-3 mb-4">
              <li><strong className="text-silver-text">Functional Cookies:</strong> Maintain your active login status, retain items in your checkout cart, and store your EA wishlist choices.</li>
              <li><strong className="text-silver-text">Preference Cookies:</strong> Remember UI state selections and user interface preferences (such as sorting or search selections).</li>
            </ul>
            <p>
              You can disable cookies in your web browser settings. However, doing so may impact checkout functionality and prevent file downloads.
            </p>
          </div>

          {/* Section 4 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">4. Contact Forms & WhatsApp Inquiries</h2>
            <p className="mb-4">
              When you submit a support request or request a custom EA through our contact and sourcing forms:
            </p>
            <p>
              The info provided (email, name, description, WhatsApp number) is strictly processed to evaluate your requests, source files, and contact you back with details. WhatsApp conversations are handled directly on official WhatsApp business numbers and are encrypted according to WhatsApp guidelines.
            </p>
          </div>

          {/* Section 5 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">5. Data Retention</h2>
            <p>
              We retain user profile data and purchase histories for as long as your account remains active on the Platform. This is necessary to offer lifetime downloads and update files. If you wish to delete your account and personal details, please contact our support team.
            </p>
          </div>

          {/* Section 6 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">6. Data Security</h2>
            <p>
              We enforce strict industry measures to safeguard your information. Our Platform uses SSL/TLS encryption for all data transit, access controls on our servers, and token-based download systems to prevent file theft and user data exposure.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
